<template>
  <div>
    <PageTable :orderCode="orderCode" />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  components: { PageTable },
  props: {
    orderCode: { type: String, default: '' },
  },
}
</script>
